import React from 'react'
import { useSnackbar } from 'notistack'
import PropTypes from 'prop-types'

export const Palette = ({ color, width, height, border, className }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const handleCopy = (c) => {
    navigator.clipboard.writeText(c)
    enqueueSnackbar('Copied! ' + c, {
      variant: 'success'
    })
  }

  return (
    <div
      className={className}
      defaultValue={color}
      onClick={() => handleCopy(color)}
      style={{
        cursor: 'pointer'
      }}>
      <div
        style={{
          background: color,
          borderRadius: `${border}px`,
          height: `${height}px`,
          width: `${width}px`,
          margin: '12px 0 0 0',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      />
      <p
        style={{
          margin: 0,
          padding: 0,
          textAlign: 'center',
          marginTop: '4px'
        }}>
        {color}
      </p>
    </div>
  )
}

Palette.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,

  width: PropTypes.number,

  height: PropTypes.number,

  border: PropTypes.number,

  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

Palette.defaultProps = {
  width: 62,
  height: 26,
  border: 6
}

Palette.displayName = 'p'

export default Palette
